import dayjs from 'dayjs'
import toObject from 'dayjs/plugin/toObject'
import objectSupport from 'dayjs/plugin/objectSupport'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isToday from 'dayjs/plugin/isToday'
import ja from 'dayjs/locale/ja';
dayjs.extend(toObject)
dayjs.extend(objectSupport)
dayjs.extend(isSameOrAfter)
dayjs.extend(isToday)
// 曜日表示を日本語化
dayjs.locale(ja);

export { dayjs as datetime }
